var _path, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalizadorDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60647 9.98158C2.76184 5.45385 6.0928 0.5 10.9819 0.5C15.9039 0.5 19.2357 5.51535 17.3279 10.0526L15.7207 13.8749L11.4771 22.0825C11.2923 22.44 10.7823 22.4437 10.5922 22.0889L6.19228 13.874L4.60647 9.98158Z",
    stroke: "#3d3d3d"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9564,
    cy: 7.82745,
    rx: 2.6087,
    ry: 2.6087,
    fill: "#3d3d3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalizadorDisabled);
export default __webpack_public_path__ + "static/media/localizadorDisabled.5fdf83f8b003bc1ca5931a00a6782ec9.svg";
export { ForwardRef as ReactComponent };